import { BeanParametroXMotivo } from "./BeanParametroXMotivo";

export class BeanParameter { 
    constructor(
        public paraIdCdParametro: string,
        public formIdCdFormulario: number,
        public paraDsParametro: string,
        public paraInObrigatorio: string,
        public paraDhInativo: string,        
        public pamoIdCdParametroFormulario: number = 0,
        public beanParametroXMotivo: BeanParametroXMotivo[] = [],
        public paraNrOrdem: string,

        //apenas para cadastro
        public isPossuiMotivo: boolean
        
    ){} 
}